// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PermissionsEditor.css */
:root {
    --primary-color: #007bff;
    --bg-color: #f9f9f9;
    --border-color: #ddd;
    --text-color: #333;
    --btn-bg: #007bff;
    --btn-hover: #0069d9;
    --move-bg: #28a745;
    --move-hover: #218838;
    --delete-bg: #dc3545;
    --delete-hover: #c82333;
  }
  
  /* Корневая обёртка редактора прав: растягивается в контейнере и не скроллится сама */
  .pe-container {
    display: flex;
    flex-direction: column;
    height: 100%;    /* 100% от .admin-content */
    overflow: hidden; /* главный контейнер без скролла */
    padding: 20px;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
  }
  
  /* Контейнер колонок: позволяет колонкам скроллиться внутри */
  .pe-columns {
    display: flex;
    gap: 20px;
    flex: 1 1;         /* заполняет вертикальное пространство */
    min-height: 0;   /* важно для overflow в children */
  }
  
  /* Одна колонка */
  .pe-column {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    overflow: hidden;
  }
  
  /* Заголовок колонки */
  .pe-col-title {
    margin: 0;
    padding: 16px;
    font-size: 20px;
    text-transform: capitalize;
    border-bottom: 1px solid var(--border-color);
  }
  
  /* Блок добавления права в колонке */
  .pe-add-inline {
    display: flex;
    gap: 8px;
    padding: 0 16px 16px;
    border-bottom: 1px solid var(--border-color);
  }
  .pe-input {
    flex: 1 1;
    padding: 6px 8px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 14px;
  }
  .pe-add-btn {
    padding: 6px 12px;
    background-color: var(--btn-bg);
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
  .pe-add-btn:hover {
    background-color: var(--btn-hover);
  }
  
  /* Список прав */
  .pe-list {
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
    margin: 0;
    padding: 0 16px 16px;
    list-style: none;
  }
  
  /* Элемент списка */
  .pe-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0;
    border-bottom: 1px solid var(--border-color);
  }
  .pe-item:last-child {
    border-bottom: none;
  }
  
  /* InlineEditor */
  .ie-container {
    display: inline-flex;
    align-items: center;
    flex: 1 1;
  }
  .ie-input {
    padding: 4px 6px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 14px;
  }
  .ie-cancel {
    background: none;
    border: none;
    color: var(--text-color);
    margin-left: 4px;
    cursor: pointer;
    font-size: 16px;
  }
  .ie-text {
    cursor: pointer;
    flex: 1 1;
    word-break: break-all;
  }
  
  /* Кнопки действий */
  .pe-move, .pe-delete {
    padding: 4px 8px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;
  }
  .pe-move {
    background-color: var(--move-bg);
    color: white;
  }
  .pe-move:hover {
    background-color: var(--move-hover);
  }
  .pe-delete {
    background-color: var(--delete-bg);
    color: white;
  }
  .pe-delete:hover {
    background-color: var(--delete-hover);
  }`, "",{"version":3,"sources":["webpack://./src/modules/Admin/AdminPanelExample/Pages/PermissionsEditor.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,wBAAwB;IACxB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA,qFAAqF;EACrF;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,KAAK,2BAA2B;IAC5C,gBAAgB,EAAE,kCAAkC;IACpD,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA,6DAA6D;EAC7D;IACE,aAAa;IACb,SAAS;IACT,SAAO,UAAU,wCAAwC;IACzD,aAAa,IAAI,kCAAkC;EACrD;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,SAAS;IACT,aAAa;IACb,eAAe;IACf,0BAA0B;IAC1B,4CAA4C;EAC9C;;EAEA,oCAAoC;EACpC;IACE,aAAa;IACb,QAAQ;IACR,oBAAoB;IACpB,4CAA4C;EAC9C;EACA;IACE,SAAO;IACP,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;EACA;IACE,kCAAkC;EACpC;;EAEA,gBAAgB;EAChB;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,4CAA4C;EAC9C;EACA;IACE,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,SAAO;EACT;EACA;IACE,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;IACf,SAAO;IACP,qBAAqB;EACvB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gCAAgC;IAChC,YAAY;EACd;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;IAClC,YAAY;EACd;EACA;IACE,qCAAqC;EACvC","sourcesContent":["/* PermissionsEditor.css */\r\n:root {\r\n    --primary-color: #007bff;\r\n    --bg-color: #f9f9f9;\r\n    --border-color: #ddd;\r\n    --text-color: #333;\r\n    --btn-bg: #007bff;\r\n    --btn-hover: #0069d9;\r\n    --move-bg: #28a745;\r\n    --move-hover: #218838;\r\n    --delete-bg: #dc3545;\r\n    --delete-hover: #c82333;\r\n  }\r\n  \r\n  /* Корневая обёртка редактора прав: растягивается в контейнере и не скроллится сама */\r\n  .pe-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;    /* 100% от .admin-content */\r\n    overflow: hidden; /* главный контейнер без скролла */\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n    font-family: Arial, sans-serif;\r\n  }\r\n  \r\n  /* Контейнер колонок: позволяет колонкам скроллиться внутри */\r\n  .pe-columns {\r\n    display: flex;\r\n    gap: 20px;\r\n    flex: 1;         /* заполняет вертикальное пространство */\r\n    min-height: 0;   /* важно для overflow в children */\r\n  }\r\n  \r\n  /* Одна колонка */\r\n  .pe-column {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    background: white;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  /* Заголовок колонки */\r\n  .pe-col-title {\r\n    margin: 0;\r\n    padding: 16px;\r\n    font-size: 20px;\r\n    text-transform: capitalize;\r\n    border-bottom: 1px solid var(--border-color);\r\n  }\r\n  \r\n  /* Блок добавления права в колонке */\r\n  .pe-add-inline {\r\n    display: flex;\r\n    gap: 8px;\r\n    padding: 0 16px 16px;\r\n    border-bottom: 1px solid var(--border-color);\r\n  }\r\n  .pe-input {\r\n    flex: 1;\r\n    padding: 6px 8px;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n  .pe-add-btn {\r\n    padding: 6px 12px;\r\n    background-color: var(--btn-bg);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n  }\r\n  .pe-add-btn:hover {\r\n    background-color: var(--btn-hover);\r\n  }\r\n  \r\n  /* Список прав */\r\n  .pe-list {\r\n    flex: 1;\r\n    min-height: 0;\r\n    overflow-y: auto;\r\n    margin: 0;\r\n    padding: 0 16px 16px;\r\n    list-style: none;\r\n  }\r\n  \r\n  /* Элемент списка */\r\n  .pe-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 8px 0;\r\n    border-bottom: 1px solid var(--border-color);\r\n  }\r\n  .pe-item:last-child {\r\n    border-bottom: none;\r\n  }\r\n  \r\n  /* InlineEditor */\r\n  .ie-container {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    flex: 1;\r\n  }\r\n  .ie-input {\r\n    padding: 4px 6px;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n  .ie-cancel {\r\n    background: none;\r\n    border: none;\r\n    color: var(--text-color);\r\n    margin-left: 4px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n  }\r\n  .ie-text {\r\n    cursor: pointer;\r\n    flex: 1;\r\n    word-break: break-all;\r\n  }\r\n  \r\n  /* Кнопки действий */\r\n  .pe-move, .pe-delete {\r\n    padding: 4px 8px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    white-space: nowrap;\r\n  }\r\n  .pe-move {\r\n    background-color: var(--move-bg);\r\n    color: white;\r\n  }\r\n  .pe-move:hover {\r\n    background-color: var(--move-hover);\r\n  }\r\n  .pe-delete {\r\n    background-color: var(--delete-bg);\r\n    color: white;\r\n  }\r\n  .pe-delete:hover {\r\n    background-color: var(--delete-hover);\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
